import { Routes } from "@angular/router";
import { ErrorComponent } from "./pages/error/error.component";
import { AppGuard } from "./app.guard";

export const ROUTES: Routes = [
  {
    path: "",
    redirectTo: "app",
    pathMatch: "full",
  },
  {
    path: "app",
    canActivate: [AppGuard],
    loadChildren: () =>
      import("./layout/layout.routes").then((m) => m.routes),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.routes").then((m) => m.routes),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.routes").then((m) => m.routes),
  },
  {
    path: "resetpassword/:token",
    loadChildren: () =>
      import("./pages/resetpassword/resetpassword.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "**",
    component: ErrorComponent,
  },
];
